import { render, staticRenderFns } from "./SetupDialog.vue?vue&type=template&id=3217c33c"
import script from "./SetupDialog.vue?vue&type=script&lang=js"
export * from "./SetupDialog.vue?vue&type=script&lang=js"
import style0 from "./SetupDialog.vue?vue&type=style&index=0&id=3217c33c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports